<script>
    import BaseButton from './common/BaseButton.svelte'
    import LoginIcon from '../assets/icons/LoginIcon.svelte'
    import LogoutIcon from '../assets/icons/LogoutIcon.svelte'
    import { onMount } from 'svelte'
    import { t } from '../i18n.js'
    import { startAuth, logOut } from '../login.js'
    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    let isLoggedIn
    onMount(() => {
		isLoggedIn = localStorage.getItem('isLoggedIn')
    })

    function clicked() {
        dispatch('clicked')
    }

    let iconColor = 'navy'
    function onHover() {
        iconColor = 'white'
    }
    function onHoverOut() {
        iconColor = 'navy'
    }
</script>

<div on:mouseenter={onHover} on:mouseleave={onHoverOut}>
    <BaseButton on:click={clicked(), isLoggedIn ? logOut : startAuth}>
        <span class="flex justify-center">
            {#if isLoggedIn}
                <span class="mr-2">
                    {$t('btn.sign-out')}
                </span>
                <LogoutIcon color={iconColor} />
            {:else}
                <span class="mr-2">
                    {$t('btn.sign-in')}
                </span>
                <LoginIcon color={iconColor} />
            {/if}
        </span>
    </BaseButton>
</div>
